/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorUnaryNot extends models.QueryOperatorUnary {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorUnaryNot");
    }

    getFixupPrototypeFunction() { return QueryOperatorUnaryNot.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorUnaryNot>): QueryOperatorUnaryNot {
        let obj = Object.assign(new QueryOperatorUnaryNot(), model);
        QueryOperatorUnaryNot.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorUnaryNot>): QueryOperatorUnaryNot {
        if (!model) return null;
        return QueryOperatorUnaryNot.newInstance(<QueryOperatorUnaryNot> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorUnaryNot) {
        if (!obj) return;

        models.QueryOperatorUnaryNot.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorUnaryNot): boolean {
        if (models.QueryOperatorUnary.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorUnaryNot.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
